/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backend_Session_Dns_LabelInputs */

const en_backend_session_dns_label = /** @type {(inputs: Backend_Session_Dns_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const fr_backend_session_dns_label = /** @type {(inputs: Backend_Session_Dns_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point d'accès`)
};

const ms_sg2_backend_session_dns_label = /** @type {(inputs: Backend_Session_Dns_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik akhir`)
};

/**
* | output |
* | --- |
* | "Endpoint" |
*
* @param {Backend_Session_Dns_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const backend_session_dns_label = /** @type {((inputs?: Backend_Session_Dns_LabelInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backend_Session_Dns_LabelInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_backend_session_dns_label(inputs)
	if (locale === "fr") return fr_backend_session_dns_label(inputs)
	return ms_sg2_backend_session_dns_label(inputs)
});